// extracted by mini-css-extract-plugin
module.exports = {"logo-container":"logo_logo-container__xnIi3","logo":"logo_logo__3bC8e"};